export default __webpack_public_path__ + "a5a095d502f902aaae5116a0ae92b68f.woff";